export default __webpack_public_path__ + "static/media/Img2@2x.e080ba88.jpg";